import { Box } from "@mui/material";
import useColors from "../../api/hooks/useColors";

export default function ToggleGroup({ children }) {
  const colors = useColors();
  return (
    <Box
      width="fit-content"
      height="32px"
      padding="2px"
      display="flex"
      borderRadius="10px"
      gap={0.5}
      alignItems="center"
      border={"1px solid " + colors.grey_12percent}
      sx={{ backgroundColor: colors.common_white }}
    >
      {children}
    </Box>
  );
}
